<template>
  <a-modal
    :title="title"
    :width="870"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <template>
      <a-form-model
        ref="ruleForm"
        :labelCol="{ span: 3 }"
        :wrapperCol="{ span: 20 }"
        :model="form"
        :rules="rules"
      >
        <a-form-model-item label="标题" prop="title">
          <a-input v-model="form.title" placeholder="请输入标题" />
        </a-form-model-item>
        <a-form-model-item v-if="isShowSort" label="选择分类" prop="classify">
          <j-dict-select-tag
            v-model="form.classify"
            placeholder="请选择分类"
            :dictCode="sortDictCode"
          />
        </a-form-model-item>
        <a-form-model-item label="详细介绍" prop="content">
          <WangEditor
            v-model="form.content"
            :editorStyle="{ minHeight: '200px' }"
            style="margin: 2px; border: 1px solid #d9d9d9; border-radius: 4px; overflow: hidden"
          />
        </a-form-model-item>
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
import WangEditor from '@/components/WangEditor'
import { postAction, putAction } from '@/api/manage'

export default {
  name: 'CreateSubjectModal',
  components: {
    WangEditor,
  },
  props: {
    title: {
      type: String,
      default: '创建',
    },
    actionUrl: {
      type: String,
      default: '/resourceTeacherGrowth',
    },
    sortDictCode: {
      type: String,
      default: 'teacher_growth_sort',
    },
    isShowSort: {
      type: Boolean,
      default: true,
    },
    actionType: {
      type: [String, Number],
      default: undefined,
    },
  },
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        classify: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        // radius: [{ required: true, message: '请选择测评范围', trigger: 'blur' }],
        // evalWay: [{ required: true, message: '请选择测评方式', trigger: 'blur' }],
      },
      currEvalInfo: {},
    }
  },
  methods: {
    showModal(data) {
      this.visible = true

      if (!data) return
      this.form = {
        id: data.id,
        title: data.title,
        classify: data.classify,
        content: data.content,
      }
    },
    hideModal() {
      this.visible = false
      this.form = {}
    },
    handleOk() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        const params = { ...this.form, type: this.actionType }
        const res = this.form.id
          ? await putAction(this.actionUrl + '/edit', params)
          : await postAction(this.actionUrl + '/add', params)
        console.log('创建：', res)
        if (res.success) {
          this.$message.success(res.message)
          this.$emit('refreshData')
          this.hideModal()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
}
</script>
<style scoped lang="less"></style>
